module.exports = __webpack_public_path__ + "img/clock.b9e52714.svg";